import {
  LocalStorageConnection,
  StorageConnection,
  UserBranchesConnection,
} from '@cotera/client/v0/models/user-branches';
import { useSuspenseQuery } from '@tanstack/react-query';

export const useStorageInit = (org: { name: string; id: string }) => {
  return useSuspenseQuery({
    queryFn: async () => {
      const storage: StorageConnection = new LocalStorageConnection(org.id);
      const branches = await UserBranchesConnection.create(org.name, storage);
      const autoPublish = await storage.getAutoPublish();

      return {
        branches,
        storage,
        autoPublish,
      };
    },
    queryKey: [org.id, 'local-storage'],
  });
};
